import styled from 'styled-components/native';

export const StyledRow = styled.View`
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-grow:  ${({ flexGrow }) => (flexGrow ? 1 : 0)} ;
`;
